import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { loadPersian } from 'moment-jalaali';
import {ReactKeycloakProvider} from '@react-keycloak/web';
import Routes from './routes';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { ErrorBoundary } from './assets/styles';
import MUIThemeProvider from './lib/mui.theme';
import Dialog from './components/Common/Dialog';
import Snackbar from './components/Common/SnackBar';
import UpdateAlert from './components/Common/UpdateAlert';
import Config from './configs/config';
import keycloak from './configs/keycloak';

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [rtlPlugin],
  prepend: true,
});

loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

const Root = () => {
  const appVersion = Config?.appVersion;
  const currentVersion = localStorage.getItem('fansat-admin-version');
  const [showReload, setShowReload] = useState(false);

  useEffect(() => {
    if (!currentVersion || currentVersion === 'undefined') {
      localStorage.setItem('fansat-admin-version', appVersion);
    }
    if (appVersion !== currentVersion) {
      setShowReload(true);
    }
  }, []);

  const reloadPage = () => {
    localStorage.setItem('fansat-admin-version', appVersion);
    window.location.reload(true);
  };

  return (
    <ReactKeycloakProvider authClient={keycloak} autoRefreshToken>
      <ErrorBoundary name="Whole Application">
        <CacheProvider value={cacheRtl}>
          <ThemeProvider theme={MUIThemeProvider}>
            <Provider store={store}>
              <Router>
                <Routes />
              </Router>
              <Dialog />
              <Snackbar />
              <UpdateAlert showReload={showReload} reloadPage={reloadPage} setShowReload={setShowReload}/>
            </Provider>
          </ThemeProvider>
        </CacheProvider>
      </ErrorBoundary>
    </ReactKeycloakProvider>
  );
};

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
